export const SORT_TYPES = {
  text: { asc: 'A \u2192 Z', desc: 'Z \u2192 A' },
  date: { asc: 'Earliest \u2192 Latest', desc: 'Latest \u2192 Earliest' },
  number: { asc: '1 \u2192 9', desc: '9 \u2192 1' },
  currency: { asc: 'Lowest \u2192 Highest', desc: 'Highest \u2192 Lowest' },
};

export const MEMBERSHIP_COLUMNS = [
  { id: 'member_name', label: 'Member Name', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'email', label: 'Email', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'product_name', label: 'Membership Product', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'status', label: 'Status', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'amount', label: 'Amount', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'interval', label: 'Interval', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'current_period_start', label: 'Current Period Start', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'current_period_end', label: 'Current Period End', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'created_at', label: 'Joined', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'venue_name', label: 'Venue Name', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'canceled_at', label: 'Canceled At', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'net_to_venue', label: 'Net to Venue', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'processing_fee', label: 'Processing Fee', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'sold_by', label: 'Sold By', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'device_name', label: 'Device', alwaysVisible: false, defaultVisible: false, sortable: false },
];

export const getDefaultVisibleColumns = () =>
  MEMBERSHIP_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  MEMBERSHIP_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
